import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import Panzoom from "@panzoom/panzoom";
import IconButton from "@/components/buttons/IconButton.vue";
import StandardButton from "@/components/buttons/StandardButton.vue";
import WToolTip from "@/components/tooltip/w-toolTip.vue";
let PanZoomViewer = class PanZoomViewer extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "buttonsPosition", void 0);
    _defineProperty(this, "MIN_ZOOM_SCALE", 0.3);
    _defineProperty(this, "MAX_ZOOM_SCALE", 10);
    _defineProperty(this, "currentZoomScale", 1);
    _defineProperty(this, "panzoomInstance", null);
    _defineProperty(this, "zoomPollInterval", null);
    _defineProperty(this, "isFullscreen", false);
  }
  mounted() {
    this.initPanzoom();
    document.addEventListener('fullscreenchange', this.onFullscreenChange);
  }
  get zoomBtnTooltipPlacement() {
    return this.buttonsPosition === 'bottom-center' ? 'top' : 'left';
  }
  get fullscreenTooltip() {
    return this.isFullscreen ? this.$t('panzoomViewer.exitFullscreenTooltip') : this.$t('panzoomViewer.fullscreenTooltip');
  }
  get canZoomIn() {
    return this.currentZoomScale < this.MAX_ZOOM_SCALE - 0.001;
  }
  get canResetOrZoomOut() {
    return Math.abs(this.currentZoomScale - 1) > 0.001;
  }
  syncZoomScale() {
    if (this.panzoomInstance) {
      this.currentZoomScale = this.panzoomInstance.getScale();
    }
  }
  initPanzoom() {
    this.destroyPanzoom();
    this.currentZoomScale = 1;
    this.$nextTick(() => {
      const el = this.$refs.contentContainer;
      if (!el) {
        return;
      }
      this.panzoomInstance = Panzoom(el, {
        maxScale: this.MAX_ZOOM_SCALE,
        minScale: this.MIN_ZOOM_SCALE,
        contain: 'outside',
        cursor: 'grab'
      });
      el.parentElement?.addEventListener('wheel', this.panzoomInstance.zoomWithWheel);
      // pour capter les eventuels / zoom en provenance du touchpad ou molette de souris
      this.zoomPollInterval = window.setInterval(() => this.syncZoomScale(), 250);
    });
  }
  destroyPanzoom() {
    if (this.panzoomInstance) {
      const el = this.$refs.contentContainer;
      el?.parentElement?.removeEventListener('wheel', this.panzoomInstance.zoomWithWheel);
      this.panzoomInstance.destroy();
      this.panzoomInstance = null;
    }
    if (this.zoomPollInterval !== null) {
      window.clearInterval(this.zoomPollInterval);
      this.zoomPollInterval = null;
    }
    this.currentZoomScale = 1;
  }
  zoomIn() {
    this.panzoomInstance?.zoomIn();
    this.syncZoomScale();
  }
  zoomOut() {
    this.panzoomInstance?.zoomOut();
    this.syncZoomScale();
  }
  resetZoom() {
    this.panzoomInstance?.reset();
    this.syncZoomScale();
  }
  async toggleFullscreen() {
    try {
      if (this.isFullscreen) {
        await document.exitFullscreen();
        return;
      }
      // c'est le viewport entier qui passe en plein ecran, pour que les controles de zoom restent accessibles
      const viewport = this.$refs.viewport;
      await viewport?.requestFullscreen();
    } catch (e) {
      // le navigateur peut refuser la demande (geste utilisateur invalide, iframe sans allowfullscreen): on reste dans l'etat courant
    }
  }
  onFullscreenChange() {
    const viewport = this.$refs.viewport;
    this.isFullscreen = !!viewport && document.fullscreenElement === viewport;
    // le viewport change de taille: on remet le zoom a plat pour que la contrainte "outside" de panzoom se recalcule proprement
    this.resetZoom();
  }
  beforeUnmount() {
    document.removeEventListener('fullscreenchange', this.onFullscreenChange);
    this.destroyPanzoom();
  }
};
__decorate([Prop({
  default: 'bottom-center'
})], PanZoomViewer.prototype, "buttonsPosition", void 0);
PanZoomViewer = __decorate([Component({
  components: {
    WToolTip,
    StandardButton,
    IconButton
  }
})], PanZoomViewer);
export default PanZoomViewer;